var map = {
	"./AaveLogo.png": 11262,
	"./AaveLogo_h.png": 17131,
	"./ChainlinkLogo.png": 39669,
	"./ChainlinkLogo_h.png": 35127,
	"./Logo.png": 6515,
	"./Path.png": 53747,
	"./Primary_Logo.png": 42478,
	"./Primary_Logo_h.png": 21147,
	"./blue_bg.png": 59790,
	"./dexview.png": 50948,
	"./dexview_h.png": 82565,
	"./discord.png": 93004,
	"./diver_icon.png": 12778,
	"./diversity.png": 14813,
	"./failed.png": 94917,
	"./fair_icon.png": 76746,
	"./footer_logo.png": 33585,
	"./head0.png": 15150,
	"./head1.png": 98295,
	"./head10.png": 62647,
	"./head11.png": 89006,
	"./head12.png": 91429,
	"./head13.png": 73916,
	"./head14.png": 57523,
	"./head15.png": 6762,
	"./head16.png": 55745,
	"./head17.png": 83032,
	"./head18.png": 84687,
	"./head19.png": 15942,
	"./head2.png": 90716,
	"./head3.png": 26629,
	"./head4.png": 56202,
	"./head5.png": 88115,
	"./head6.png": 92504,
	"./head7.png": 13633,
	"./head8.png": 85766,
	"./head9.png": 67311,
	"./home_logo.png": 81001,
	"./icon.png": 91241,
	"./language.png": 69728,
	"./left_i.png": 91049,
	"./less_icon.png": 24657,
	"./lessbg.png": 60236,
	"./mobile.png": 71104,
	"./pending.png": 20137,
	"./pinkSale.png": 70199,
	"./pinkSale_h.png": 43498,
	"./play1.png": 16375,
	"./play2.png": 8796,
	"./play3.png": 44709,
	"./predict.png": 65883,
	"./predict1.png": 15498,
	"./predict2.png": 29729,
	"./predict3.png": 8600,
	"./predict4.png": 57591,
	"./predict5.png": 12014,
	"./purple.png": 12364,
	"./right_i.png": 67046,
	"./s_icon.png": 90583,
	"./success.png": 98117,
	"./twitter.png": 44997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65373;